import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const MortgageFinancing = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Mortgage Financing</Text>

      <Text style={styles.text}>
        1. This sale is contingent upon Buyer obtaining mortgage financing
        according to the terms outlined below. Upon receiving documentation
        demonstrating the mortgage lender’s approval (conditional or outright)
        of Buyer’s mortgage application(s) according to the following terms,
        Buyer will promptly deliver a copy of the documentation to Seller, but
        in any case no later than :{' '}
        <Text style={styles.ClauseText}>
          {contract?.offerSpecifics?.financingCommittmentDate ?? 'N/A'}
        </Text>
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>1. Proposed First Mortgage</Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            i. Loan program:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.financingLoanProgram ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            ii. Loan amount:{' '}
            <Text style={styles.InfoText}>
              {contract?.offerSpecifics?.loanAmount ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            iii. Loan term:{' '}
            <Text style={styles.InfoText}>
              {contract?.offerSpecifics?.loanTerm ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            iv. Market interest rate:{' '}
            <Text style={styles.InfoText}>
              {contract?.offerSpecifics?.marketInterestRate ?? 'N/A'}%
            </Text>
          </Text>
          <Text style={styles.listItem}>
            v. Lender:{' '}
            <Text style={styles.InfoText}>
              {contract?.offerSpecifics?.lenderName ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            vi. Lender address:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.lenderAddress ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            vii. Lender NMLS:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.lenderNMLS ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            viii. Loan officer:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.loanOfficerName ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            ix. Loan officer phone:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.loanOfficerPhone ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            x. Loan officer email:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.loanOfficerEmail ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            xi. Loan officer NMLS:{' '}
            <Text style={styles.ClauseText}>
              {contract?.offerSpecifics?.loanOfficerNMLS ?? 'N/A'}
            </Text>
          </Text>
          <Text style={styles.listItem}>
            xii. Pre-Approval Letter is attached to this contract.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default MortgageFinancing;
